import { render, staticRenderFns } from "./ViewMortgageLoans.vue?vue&type=template&id=982b57a0&scoped=true"
import script from "./ViewMortgageLoans.vue?vue&type=script&lang=js"
export * from "./ViewMortgageLoans.vue?vue&type=script&lang=js"
import style0 from "./ViewMortgageLoans.vue?vue&type=style&index=0&id=982b57a0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982b57a0",
  null
  
)

export default component.exports